import { Injectable } from '@angular/core';
import { IDatosEmpleadosService } from './i-datos-empleados-service';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { EmpleadoCrud } from '../../models/empleado';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { RecuperaEmpresasApiService } from 'src/app/pages/configuracion/maestros/empresas/services/recupera-empresas-api.service';
import { DatosCentrosService } from 'src/app/pages/configuracion/maestros/centros/services/datos-centros.service';
import { environment } from 'src/environments/environment';
import { FiltroEmpleado } from 'src/app/shared/models/filtros';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';

@Injectable({
  providedIn: 'root'
})
export class RecuperaEmpleadosApiService implements IDatosEmpleadosService{

  // private readonly URL_GET_EMPLEADOS: string = this.endpointService.UrlGetEmpleadosData;
  private readonly URL_GET_EMPLEADOS: string = `${environment.ApiUrlV3}api/Empleados/GetEmpleados`;
  private readonly URL_ADD_EMPLEADO: string = this.endpointService.UrlEmpleadoAddEmpleados;
  private readonly URL_UPDATE_EMPLEADO: string = this.endpointService.UrlUpdateEmpleado;
  private readonly URL_DELETE_EMPLEADO: string = this.endpointService.UrlDeleteEmpleado;
  private readonly URL_CONFIGURACION_APLICACION: string = this.endpointService.UrlGetConfiguracionAplicacion;
  empleados: EmpleadoCrud[];

  constructor(private loginService: LoginService,
              private endpointService: EndpointService,
              private httpClient: HttpClient,
              private conversionDatosApiService: ConversionDatosApiService,
              private datosEmpresasApiService : RecuperaEmpresasApiService,
              private datosCentrosService: DatosCentrosService) { }


   getEmpleados(filtroEmpleados: FiltroEmpleado[], pageNumber:number, pageSize:number = 100, orden: OrdenColumna = {campoOrden:'', orden:''}): Observable<EmpleadoCrud[]> {

    let filtrosEmpresa = filtroEmpleados.find(x=>x.text=='Empresa')?.listaValores.join(',');
    let filtrosCentro = filtroEmpleados.find(x=>x.text=='Centro')?.listaValores.join(',');
    let filtroNif = filtroEmpleados.find(x=>x.text=='Nif')?.listaValores.join(',');
    let filtroBuscar = filtroEmpleados.find(x=>x.text=='Buscar')?.buscar;

    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('filtros[EMPRESA]', filtrosEmpresa ? filtrosEmpresa : '')
      .set('filtros[CENTRO]', filtrosCentro ? filtrosCentro : '')
      .set('filtros[NIF]', filtroNif ? filtroNif : '')
      .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
    }
    if(orden.campoOrden && orden.campoOrden == 'nombreEmpresa'){
      httpOptions.params = httpOptions.params.set('orden[EMPRESA]', orden.orden);
    }else if(orden.campoOrden && orden.campoOrden == 'nombreCentro'){
      httpOptions.params = httpOptions.params.set('orden[CENTRO]', orden.orden);
    }else if (orden.campoOrden) {
      httpOptions.params = httpOptions.params.set(`orden[${orden.campoOrden.toUpperCase()}]`, orden.orden);
    }

    return this.httpClient.get(this.URL_GET_EMPLEADOS, httpOptions).pipe(
      map((response: any) => {
        this.empleados = this.conversionDatosApiService.mapEmpleadosEntrada(response);
        return this.empleados;
      })
    );
  }

  addEmpleado(data: any): Observable<void> {
    data = this.conversionDatosApiService.mapUpdateEmpleadoSalida(data);
    data = [data];
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.httpClient.post<void>(this.URL_ADD_EMPLEADO, data, options)
  }

  updateEmpleado(data: any): Observable<void> {
    data = this.conversionDatosApiService.mapUpdateEmpleadoSalida(data);
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.httpClient.post<void>(this.URL_UPDATE_EMPLEADO, data, options)
  }

  deleteEmpleado(codigo: string): Observable<any> {

    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.httpClient.delete<any>(this.URL_DELETE_EMPLEADO.replace("{codigoEmpleado}", codigo), options)
    .pipe(
      map(resp=>{

      }),
      catchError(error => {
        return throwError("No se ha eliminado el empleado.");
      })
    );
  }

  getConfiguracionAplicacion():Observable<any>{
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.httpClient.get(this.URL_CONFIGURACION_APLICACION, options).pipe(
      map((response: any) =>{
        if (response) {
            // response.TipoIntegracion = 'A3'; //BORRAR
          // response.TipoIntegracion = 'Meta4Cloud';
          return response;
        }
        else throw new Error(response);
      })
    );
  }

}


